module.exports = __webpack_public_path__ + "assets/img/0602.18e40ff8.svg";